module.exports = __webpack_public_path__ + "static/media/Character.7064263a.svg";